import {mande} from "mande";



export const userLookup = (officeId) => {
    return mande(TABS.api.getEndPoint('optima-user-lookup', TABS.api.version, officeId))
}

export const registerStudentWithContact = (officeId) => {
    return mande(TABS.api.getEndPoint('optima-register-student-with-contact', TABS.api.version, officeId))
}

export const getOfficeAndProductTerms = (officeId) => {
    return mande(TABS.api.getEndPoint('optima-office-product-terms', TABS.api.version, officeId))
}

export const postCompleteFollowUp = () => {
    return mande(TABS.api.getEndPoint('do_booking', TABS.api.version))
}